// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5db03bd9","453":"30564bb5"}[chunkId] + ".chunk.js";
};